import { render } from "./IncomeNew.vue?vue&type=template&id=16f7d8f4"
import script from "./IncomeNew.vue?vue&type=script&lang=js"
export * from "./IncomeNew.vue?vue&type=script&lang=js"

import exportComponent from "/home/umut/Desktop/tm-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__